import { createModel } from '@/store/tools';

const model = {
    namespace: 'audit',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getAuditList': T('getAuditList'),
            'getAuditStatus': T('getAuditStatus'),
            'getBrokerInfo': T('getBrokerInfo'),
            'getOperatorInfo': T('getOperatorInfo'),
            'getAuditAreaList': T('getAuditAreaList'),
        },
        actions: {
            'getAuditList': A('getAuditList'),
            'getAuditStatus': A('getAuditStatus'),
            'getBrokerInfo': A('getBrokerInfo'),
            'getOperatorInfo': A('getOperatorInfo'),
            'getAuditAreaList': A('getAuditAreaList'),
        },
        sagas: {
            'getAuditList': S('getAuditList', '/?cmd=com.xqxc.api.pig.mis.biz.user.company.AuditRecordMisService.auditRecordPage'),
            'getAuditStatus': S('getAuditStatus', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getBrokerInfo': S('getBrokerInfo', '/?cmd=com.xqxc.api.pig.mis.biz.account.UserAccountMisService.getUserBrokerInfo'),
            'getOperatorInfo': S('getOperatorInfo', '/?cmd=com.xqxc.api.pig.mis.biz.user.company.AuditRecordMisService.auditInfoCompany'),
            'getAuditAreaList': S('getAuditAreaList', '/?cmd=com.xqxc.api.pig.mis.biz.user.company.OperationAreaInfoMisService.findOperationAreaInfoPage'),
        },
        reducers: {
            'auditList': R('getAuditList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'auditStatus': R('getAuditStatus', []),
            'brokerInfo': R('getBrokerInfo', {}),
            'operatorInfo': R('getOperatorInfo', { companyBaseInfo: {}, companyFinancialBaseInfo: {} }),
            'auditAreaList': R('getAuditAreaList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
        }
    })
};
export default createModel(model);